export enum navigationButtons {
    RESOURCES = "Available Resources",
    NEXT = "Next",
    BACK = "Back",
    CLOSE = "Close",
    EXIT = "Back",
    LEARN = "Click to Learn More",
    NEXT_TASK = "Next Task",
    PREVIOUS_TASK = "Previous Task",
    RETURN_TO_TASK = "Return to Current Task",
    RETURN_TO_OVERVIEW = "Return to Overview"
  }

  export enum headerNavigation {
    EXIT = "Back",
    TASKS = "Tasks",
    RESOURCES = "Resources",
    DOCUMENTS = "Documents",
    OVERVIEW = "Overview",
    LEARN = "Learn More"
  }

  export enum navigationIcons {
    DOCUMENTS = "folder open outline",
    EXIT = "window close outline",
    HELP = "help",
    LEARN = "graduation cap",
    OVERVIEW = "star",
    RESOURCES = "file alternate outline",
    TASKS = "tasks",
  }
